import React, { useState, useEffect } from 'react';
import './TopBar.css';
import { useHeading } from '../admin/HeadingContext'; // Correctly import useHeading

const TopBar = () => {
  const { heading, setHeading } = useHeading(); // Use the custom hook for heading

  const [newHeading, setNewHeading] = useState(''); // Input for admin to update the heading

  // Handle posting a new heading
  const handlePostHeading = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        'https://bombaydentalcompany.com/bombaydentalcompanyapi/heading_xhh3e7.php',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ heading: newHeading }), // Assuming the API expects this format
        }
      );

      if (response.ok) {
        setHeading(newHeading); // Update the displayed heading
        setNewHeading(''); // Clear the input field
        alert('Heading updated successfully!');
      } else {
        console.error('Failed to post heading:', response.statusText);
        alert('Failed to update the heading. Please try again.');
      }
    } catch (error) {
      console.error('Error posting heading:', error);
      alert('Error updating heading.');
    }
  };

  return (
    <div className="top-bar-container">
      <h1>{heading}</h1> {/* Display the current heading */}

      {/* Admin form to update the heading */}
      <form onSubmit={handlePostHeading} className="heading-form">
        <input
          type="text"
          value={newHeading}
          onChange={(e) => setNewHeading(e.target.value)}
          placeholder="Enter new heading"
          required
        />
        <button type="submit">Update Heading</button>
      </form>
    </div>
  );
};

export default TopBar;
